export const processImageForAvatar = (file, targetSize = 300) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      
      const { width, height } = img;
      
      // If image is already square and correct size, return as is
      if (width === height && width === targetSize) {
        resolve(file);
        return;
      }
      
      // Set canvas to target size
      canvas.width = targetSize;
      canvas.height = targetSize;
      
      // Fill with white background
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, targetSize, targetSize);
      
      // Calculate dimensions to fit image while maintaining aspect ratio
      const aspectRatio = width / height;
      let drawWidth, drawHeight, offsetX, offsetY;
      
      if (width < targetSize && height < targetSize) {
        // Scale up small images to fit
        const scale = Math.min(targetSize / width, targetSize / height);
        drawWidth = width * scale;
        drawHeight = height * scale;
        offsetX = (targetSize - drawWidth) / 2;
        offsetY = (targetSize - drawHeight) / 2;
      } else if (aspectRatio > 1) {
        // Landscape
        drawHeight = targetSize;
        drawWidth = targetSize * aspectRatio;
        offsetX = (targetSize - drawWidth) / 2;
        offsetY = 0;
      } else {
        // Portrait or square
        drawWidth = targetSize;
        drawHeight = targetSize / aspectRatio;
        offsetX = 0;
        offsetY = (targetSize - drawHeight) / 2;
      }
      
      // Draw image centered with proper scaling
      if (drawWidth > targetSize || drawHeight > targetSize) {
        // Scale down oversized dimensions
        const scale = Math.min(targetSize / drawWidth, targetSize / drawHeight);
        drawWidth *= scale;
        drawHeight *= scale;
        offsetX = (targetSize - drawWidth) / 2;
        offsetY = (targetSize - drawHeight) / 2;
      }
      
      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      
      canvas.toBlob((blob) => {
        const processedFile = new File([blob], file.name, {
          type: "image/jpeg",
        });
        resolve(processedFile);
      }, "image/jpeg", 0.9);
    };
    
    img.src = URL.createObjectURL(file);
  });
};